import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import URL from "../../constant/URL";
import TYPE from "../../constant/TYPE";
import http from "../../http/http";
import Popup from "../common/Popup";
import PopupTrigger from "../common/PopupTrigger";
import useAsideState from "../../hooks/useAsideState";
import lottie from "lottie-web";
import MenuButton from "../navigate/MenuButton";
import KillAppButton from "../navigate/KillAppButton";
// import useAiDiagnosisTestData from "../../hooks/useAiDiagnosisTestData";
import useLoading from "../../hooks/useLoading";
import useSound from "../../hooks/useSound";
import A from "../common/A";
import { useUserInfo } from "../../hooks";
import { useDispatch, useSelector } from 'react-redux';
import { appKillOnOff, getUserAgent } from "../../utils/utilityEtc";
import { mathpidLogAPICall } from "../../redux/logData";

let infoCount = 0;
let topicCount = 0;
let courseCount = 0;

const SelectLearning = withRouter((props) => {
  const { info } = useUserInfo();
  const logDispatch = useDispatch();
  const pmInfo = useSelector(state => state.pmNotice.info)
  const { setLoading, clearLoading } = useLoading();
  const { setAsideState } = useAsideState();
  // const { setAiDiagnosisTestData } = useAiDiagnosisTestData();
  const { setSound, playSound, clearSound } = useSound();
  const [modalFlag, setModalFlag] = React.useState(false);

  useEffect(() => {
    appKillOnOff('Y');

    
    logDispatch(mathpidLogAPICall({
      verbId: 'accessed',
      objectId: 'screen',
      screenVersion: 'screenCode',
      screenCode: 'scr_0000_0000',
    }));

    return () => appKillOnOff('N');
  }, [])

  const setTab = () => {
    setAsideState({ tab: "home" });
  };

  const movePage = (page) => {
    if (page !== "introduction") {
      playSound();
    }
    let pathname = "";
    let diagnosisComplete = localStorage.getItem("ai.diagnosis.check"); //진단이력 완료여부
    // let diagnosisCompletePageCheck = localStorage.getItem('ai.diagnosis.result.check'); //진단이력 완료 페이지확인
    // let diagnosisMemberCheck = localStorage.getItem('ai.diagnosis.member.check'); //학습회원여부 차후 단독app개발시 사용

    if (page === "course") {
      // setAiDiagnosisTestData({selectLearning : 'course'});
      setAsideState({ tab: "course" });

      if (diagnosisComplete === "N") {
        setModalFlag(true);
        return;
      } else {
        setAsideState({ tab: "course" });
        localStorage.setItem("learning.id", TYPE.LEARNING.COURSE);
        pathname = URL.COURSE_LEARNING.LIST;
      }
    } else if (page === "topicLearning") {
      // setAiDiagnosisTestData({selectLearning : 'topic'});
      setAsideState({ tab: "topic" });
      // pathname = Url.TOPIC_LEARNING;
      pathname = URL.TOPIC_LEARNING;
      localStorage.setItem("learning.id", TYPE.LEARNING.TOPIC);
    } else if (page === "introduction") {
      pathname = URL.INTRODUCTION;
    }
    props.history.push({ pathname });
  };

  const moveGuide = () => {
    localStorage.setItem("learning.id", TYPE.LEARNING.COURSE);
    setAsideState({ tab: "course" });
    props.history.push({
      pathname: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION,
    });
  };

  const renderModal = () => {
    return (
      <PopupTrigger
        onClose={() => {
          setModalFlag(false);
        }}
      >
        <Popup buttonLabel={["확인", "취소"]} onConfirm={(e) => moveGuide()}>
          <p className="lc-alert_txt m-fw-normal">
            AI 진단테스트 후<br />
            이용해 주세요.
          </p>
        </Popup>
      </PopupTrigger>
    );
  };

  const renderAniCourse = () => {
    if (document.getElementById("ani_course")) {
      let data = {
        container: document.getElementById("ani_course"),
        path: `${process.env.PUBLIC_URL}/static/json/img_lc_01_02_01.json`,
        renderer: "svg",
        loop: false,
        autoplay: true,
      };
      let anim = lottie.loadAnimation(data);
      anim.addEventListener("DOMLoaded", (e) => {
        courseCount = 1;
        closeLoading();
      });
    }
  };

  const renderAniTopic = () => {
    if (document.getElementById("ani_topic")) {
      let data = {
        container: document.getElementById("ani_topic"),
        path: `${process.env.PUBLIC_URL}/static/json/img_lc_01_02_02.json`,
        renderer: "svg",
        loop: false,
        autoplay: true,
      };
      let anim = lottie.loadAnimation(data);
      anim.addEventListener("DOMLoaded", (e) => {
        topicCount = 1;
        closeLoading();
      });
    }
  };

  const getCourseInfo = () => {
    setSound({
      src: `${process.env.PUBLIC_URL}/static/audio/lc_05_02_open.ogg`,
    });

    http.request({
      url: `${URL.API.DIAGNOSIS.INFO}`,
      method: http.METHOD.POST,
      data: { lrnMbrId: info.learnerId},
      success: (res) => {
        localStorage.setItem("ai.diagnosis.check", res.dgnsYn);
        localStorage.setItem("ai.diagnosis.result.check", res.dgnsRsltCnfmYn);
        localStorage.setItem("ai.diagnosis.member.check", res.memberYn);
        infoCount = 1;
        closeLoading();
      },
      error: (err) => {
        if (err) {
          infoCount = 1;
          closeLoading();
        }
      },
    });
  };

  const closeLoading = () => {
    if (infoCount && topicCount && courseCount) {
      clearLoading();
    }
  };

  const onLoading = () => {
    setLoading({ isShowSpinner: true, spinnerType: "1" });
  };

  const mount = () => {
    return () => clearSound();
  };

  React.useEffect(onLoading, []);
  React.useEffect(mount, []);
  React.useEffect(setTab, []); //사이드메뉴값
  React.useEffect(getCourseInfo, []); //코스학습이력조회
  React.useEffect(renderAniCourse, []);
  React.useEffect(renderAniTopic, []);

  return (
    <>
      <div className="header_top">
        <div className="inner">
          <div className="btns_wrap header-trans">
            {/*<div className="login cls hide_app">*/}
            {/*<a href="#null">로그인</a>*/}
            {/*<span></span>*/}
            {/*<a href="#null">회원가입</a>*/}
            {/*</div>*/}
            <div className="login cls">
              <KillAppButton />
            </div>
            <div className="right_area">
              <div className="menu_btn">
                <MenuButton />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="layout-def with_bottom_area choice">
        <div className="container">
          <div className="inner">
            <div className="center_wrap">
              <h1>학습을 선택해 주세요.</h1>
              <div className="box_wrap cls">
                {pmInfo?.noticeFlag ? (
                  <div className="home_noti">
                    <b>{pmInfo?.noticeMessage}</b>
                  </div>
                ) : null}
                <A
                  onClick={(e) => {
                    e.stopPropagation();
                    movePage("course");
                  }}
                >
                  <span className="upper">
                    <div className="anim-wrap" id="ani_course"></div>
                  </span>
                  <span className="lower">코스학습</span>
                </A>
                <A
                  onClick={(e) => {
                    e.stopPropagation();
                    movePage("topicLearning");
                  }}
                >
                  <span className="upper">
                    <div className="anim-wrap" id="ani_topic"></div>
                  </span>
                  <span className="lower">주제학습</span>
                </A>
              </div>
            </div>
            <div
              className="bottom_wrap btn_wrap"
              onClick={(e) => {
                e.stopPropagation();
                movePage("introduction");
              }}
            >
              <A
                className="box_btn"
                onClick={(e) => {
                  e.stopPropagation();
                  movePage("introduction");
                }}
              >
                강력한 AI 기술로 완성된 새로운 연산 학습법!{" "}
              </A>
            </div>
          </div>
        </div>
      </div>
      {modalFlag && renderModal()}
    </>
  );
});

export default SelectLearning;
